import { array_remove } from "../util";

export default class OdpocetFormCtrl{

  typOdpoctuOptions = [
    {"label": "K - Kontrolný", value: "K"},
    {"label": "F - Fakturačný", value: "F"},
    {"label": "Z - Zmena dodávateľa", value: "Z"},
    {"label": "P - Prepis (zmena zákazníka)", value: "P"},
    {"label": "N - Kontrolný odpočet Novým dodávateľom", value: "N"},
    {"label": "U - Ukončenie dodávky", value: "U"},
  ];

  constructor(SamoodpocetService, MeradloService){
    this.rows = [];
    this.SamoodpocetService = SamoodpocetService;
    MeradloService.listMy().then(meradla => {
      meradla.forEach(meradlo => {
        this.addRow(meradlo.odberneMiesto.kod, meradlo.cislo)
      });
    })
  }

  addRow(om, meradlo){
    this.rows.push({
      kodOM: om||"",
      cisloMeradla: meradlo||""
    });
  }

  removeRow(row){
    array_remove(this.rows, row);
  }

  save(){
    this.rows = this.rows.filter(row => row.kodOM!="" || row.cisloMeradla != "");
    this.SamoodpocetService.submit(this.rows);
  }
  
}


// WEBPACK FOOTER //
// ./src/Odpocet/OdpocetFormCtrl.js